import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import {
  downloadDocApiCall,
  viewDocApiCall,
} from "./constants/HandleChangeFunctions";
import { UploadDocumentRowOptions } from "./UploadDocumentRowOptions";
import { useSelector } from "react-redux";
import { hasPermission } from "../Utils/UtilityFunctions";
export default function UploadDocumentTable({
  setLoading,
  dispatch,
  customerId,
  setIsOpen,
  open,
  toggleModal,
  setFields,
  setEditingRow,
  setEditedDocumentName,
  setEditedDocumentType,
  deleteDocument,
  setButtonText,
  setMessageForPopUp,
  columns,
  docTableMockData,
  setProfileData,
}) {

  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const documentPermission = hasPermission(permissionsMap, "miscellaneous", "document")
  return (
    <MaterialReactTable
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          enableHiding: true,
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          fontFamily: "Inter,sans-serif",
          color: "#343A40",
          padding: "4px"
        },
      }}
      muiTablePaperProps={{
        elevation: 0,
      }}
      muiTableBodyCellProps={{
        sx: {
          fontFamily: "Inter,sans-serif",
          padding: "4px"
          //   border: "none",
        },
      }}
      enableDensityToggle={false}
      renderRowActionMenuItems={({ closeMenu, row }) => [
        documentPermission && documentPermission?.has("view")?
        <MenuItem
          key={`${row.index}.1`}
          onClick={() => {
            viewDocApiCall(
              dispatch,
              setLoading,
              customerId,
              row.original.documentName,
              setProfileData
            ),
              closeMenu();
          }}
        >
          <i className="ri-survey-line me-2" /> Preview
        </MenuItem>:null,
        documentPermission && documentPermission?.has("update")?
        <MenuItem
          key={`${row.index}.2`}
          onClick={() => {
            setFields(true),
              closeMenu(),
              setEditingRow(row.index),
              setEditedDocumentName(row.original.documentName),
              setEditedDocumentType({
                value: row.original.documentType,
                label: row.original.documentType,
              });
          }}
        >
          <i className="ri-edit-box-line me-2" /> Edit
        </MenuItem>:null,
        documentPermission && documentPermission?.has("download")?
        <MenuItem
          key={`${row.index}.3`}
          onClick={() => {
            downloadDocApiCall(
              dispatch,
              setLoading,
              customerId,
              row.original.documentName
            ),
              closeMenu();
          }}
        >
          <i className="ri-download-line me-2" /> Download
        </MenuItem>:null,
        row.original.status !== "Approved" && (
          documentPermission && documentPermission?.has("delete")?
          <MenuItem
            key={`${row.index}.4`}
            onClick={(e) => {
              closeMenu();
              e.stopPropagation();
              toggleModal(setIsOpen, open);
              deleteDocument(customerId, row.original.documentName);
              setButtonText("Delete");
              setMessageForPopUp(
                `Are you sure you want to Delete this document \'${row.original.documentName}\'?`
              );
            }}
          >
            <i className="ri-delete-bin-5-line me-2" />
            Delete
          </MenuItem>:null
        ),
      ]}
      enableRowActions
      enableBottomToolbar={false}
      enableSorting={false}
      enableColumnActions={true}
      enablePagination={false}
      enableTopToolbar={false}
      data={docTableMockData}
      columns={columns}
    />
  );
}
